import axios from 'axios';

const API_URL = process.env.REACT_APP_QUOTE_API;

export const fetchCustomerAndQuotes = async (user_id) => {

  try {
     // Send user_id in the request headers
     const response = await axios.get(`${API_URL}/home/customer-quotation-details`, {
      params: { user_id }  // Sending user_id as a query parameter
    });

    if (!response || !response.data) {
      throw new Error('Failed to fetch data: Unexpected response structure');
    }
    return response.data;
  } catch (error) {
    if (error.response && error.response.data) {
      throw new Error(error.response.data);
    } else {
      throw new Error('Failed to connect to the server');
    }
  }
};